import React from 'react';

import cn from '~/Utils/cn';

import { useMiniDrawer } from './MiniDrawerContext';
import type { MiniDrawerCustomProps } from './types';

const MiniDrawerCustom: React.FC<MiniDrawerCustomProps> = ({ children, className }) => {
  const context = useMiniDrawer();

  return <div className={cn(className)}>{children(context)}</div>;
};

export default MiniDrawerCustom;
